import {ref} from "vue";

let authToken = ref<string | null>(null)
authToken.value = null;

if (process.client) {
    authToken = useCookie('auth-token', { maxAge: 5184000 });
}

export {authToken}